let width = $(window).width();

if (width > 768) {
  let container = $(".diary .container").width();
  $(".diary .bck").width((width - container) / 2 + 2 + "px");
}
